import { useQuery } from "@apollo/client";
import { useShallow } from "zustand/react/shallow";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { isSelfHostedDistribution } from "utils/distribution";

import { useSelfHostedEnabledCloudIntegrationsStore } from "./useStore";
import { GET_ENABLED_CLOUD_INTEGRATIONS } from "./gql";

const isSelfHosted = isSelfHostedDistribution();

const useSelfHostedEnabledCloudIntegrations = () => {
  const { onError } = useTypedContext(FlashContext);

  const { setIsLoading, setAwsIntegrationsEnabled, setAzureIntegrationsEnabled } =
    useSelfHostedEnabledCloudIntegrationsStore(
      useShallow((state) => ({
        setIsLoading: state.setIsLoading,
        setAwsIntegrationsEnabled: state.setAwsIntegrationsEnabled,
        setAzureIntegrationsEnabled: state.setAzureIntegrationsEnabled,
      }))
    );

  const { loading } = useQuery(GET_ENABLED_CLOUD_INTEGRATIONS, {
    onCompleted: (data) => {
      setAwsIntegrationsEnabled(data.awsIntegrationsEnabled);
      setAzureIntegrationsEnabled(data.azureIntegrationsEnabled);
    },
    onError,
    skip: !isSelfHosted,
  });

  setIsLoading(loading);

  return undefined;
};

export default useSelfHostedEnabledCloudIntegrations;
